import { createJsonHeaders } from 'api'
import {
  BASE_URL,
  AUTH0_CAREPLAN_REDIRECT_FLAG,
  AUTH0_SESSION_PROBE_FLAG,
  AUTH0_SESSION_PROBED_FLAG,
} from 'configs'

export const hasAuth0RedirectFlag = () => {
  try {
    return sessionStorage.getItem(AUTH0_CAREPLAN_REDIRECT_FLAG) === '1'
  } catch {
    return false
  }
}

const hasAlreadyProbed = () => {
  try {
    return sessionStorage.getItem(AUTH0_SESSION_PROBED_FLAG) === '1'
  } catch {
    return false
  }
}

const markProbed = () => {
  try {
    sessionStorage.setItem(AUTH0_SESSION_PROBED_FLAG, '1')
  } catch {
    // ignore
  }
}

const setProbeFlag = active => {
  try {
    if (active) {
      sessionStorage.setItem(AUTH0_SESSION_PROBE_FLAG, '1')
    } else {
      sessionStorage.removeItem(AUTH0_SESSION_PROBE_FLAG)
    }
  } catch {
    // ignore
  }
}

/** Silent GET /getAdminUser — true while the session cookie is valid; a 401 never logs out. */
export const probeAdminSession = async () => {
  setProbeFlag(true)
  try {
    const response = await fetch(`${BASE_URL}/getAdminUser`, {
      credentials: 'include',
      method: 'GET',
      headers: createJsonHeaders(),
    })
    return response.ok
  } catch {
    return false
  } finally {
    setProbeFlag(false)
  }
}

/**
 * After Auth0 authorize returns, the backend may have set the session cookie
 * while SPA localStorage is still false. Probe getAdminUser; on success the
 * caller should authenticate() so Redux/localStorage catch up.
 *
 * Uses AUTH0_SESSION_PROBE_FLAG so a 401 does not trigger global session-expiry logout.
 */
export const resumeAuth0Session = async () => {
  if (!hasAuth0RedirectFlag()) return false
  if (hasAlreadyProbed()) return false

  setProbeFlag(true)
  try {
    const response = await fetch(`${BASE_URL}/getAdminUser`, {
      credentials: 'include',
      method: 'GET',
      headers: createJsonHeaders(),
    })
    if (!response.ok) {
      markProbed()
      return false
    }
    return true
  } catch {
    markProbed()
    return false
  } finally {
    setProbeFlag(false)
  }
}
